/**
 * Input — vendored from shadcn/ui and restyled per style guide §7.2 (NFR-008).
 *
 * 36px, 14/400 navy-950, 1px navy-500 border (an enabled control boundary must
 * clear 3:1; navy-300 does not), placeholder navy-600. Invalid state reads
 * `aria-invalid`; disabled keeps text at navy-600 on navy-100. Tenant IDs, codes
 * and other mono values pass `className="font-mono"` (CLAUDE.md §5).
 */
import * as React from 'react'

import { cn } from './cn'

export const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-navy-500 bg-white px-3 text-body text-navy-950 transition-colors duration-[var(--duration-fast)]',
        'placeholder:text-navy-600 hover:border-navy-600',
        'focus-visible:border-brand-sky focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]',
        'aria-invalid:border-[var(--color-error-600)]',
        'read-only:bg-navy-50 read-only:hover:border-navy-500',
        'disabled:cursor-not-allowed disabled:border-navy-400 disabled:bg-navy-100 disabled:text-navy-600',
        'file:border-0 file:bg-transparent file:text-body-sm file:font-medium file:text-navy-950',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
